import { Component } from '@angular/core';
import { AppConfig } from '../app.config';

@Component({
  // moduleId: module.id,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent {
  currentDate: Date = new Date();
  version: string;

  constructor() {
    this.version = AppConfig.settings.version;
  }
}
